module.exports = __webpack_public_path__ + "static/media/cses-part-01.d05fa8fe.md";